import { POIUtility } from '../models/POI';
import type { ImportedWaypoint } from './ImportFileHelper';

export type PoiHighlightInput = {
  type: string;
  name?: string | null;
  serpName?: string | null;
  description?: string | null;
  lng: number;
  lat: number;
};

export type HikeHighlightPayload = {
  type: string;
  title: string;
  description: string;
  coordinates: [number, number];
  images: [];
};

export function poiToHikeHighlight(poi: PoiHighlightInput): HikeHighlightPayload {
  return {
    type: POIUtility.fromString(poi.type).serverType(),
    title: poi.name || poi.serpName || poi.type,
    description: poi.description || '',
    coordinates: [poi.lng, poi.lat],
    images: [],
  };
}

export type ImportedWaypointHighlight = {
  type: string;
  title: string;
  description: string;
  coordinates: [number, number];
};

/**
 * Map a waypoint pulled from an imported file (GPX <wpt>, KML placemark, GeoJSON
 * Point) into the payload shape the `addHikeHighlight` store mutation expects.
 * Imported waypoints carry no POI category, so they default to the generic
 * "other" type and fall back to a sensible title when unnamed.
 */
export function importedWaypointToHikeHighlight(wp: ImportedWaypoint): ImportedWaypointHighlight {
  return {
    type: wp.type && wp.type.trim() ? wp.type : 'other',
    title: (wp.name && wp.name.trim()) || 'Imported waypoint',
    description: wp.description || '',
    coordinates: [wp.lng, wp.lat],
  };
}
